import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCategoryClick = (url: string) => {
    window.open(url, '_blank', 'noopener');
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md mx-auto" id="categories">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between gap-3 bg-background-50 border border-background-200/70 rounded-xl px-5 py-4 text-foreground-900 hover:border-accent-300 transition-all duration-200 cursor-pointer"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-grid-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
          </div>
          <div className="text-left">
            <span className="text-sm font-semibold block">Browse Product Categories</span>
            <span className="text-xs text-foreground-500">Shop by category on our main store</span>
          </div>
        </div>
        <i className={`ri-arrow-down-s-line text-foreground-400 w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-background-200/70 rounded-xl shadow-lg overflow-hidden z-50 max-h-[340px] overflow-y-auto">
          <div className="py-1">
            {categories.map((cat) => (
              <button
                key={cat.name}
                onClick={() => handleCategoryClick(cat.url)}
                className="w-full flex items-center gap-3 px-5 py-3 text-left hover:bg-background-50 transition-colors cursor-pointer group"
              >
                <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center group-hover:bg-accent-100 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-foreground-600 group-hover:text-accent-600 w-4 h-4 flex items-center justify-center`}></i>
                </div>
                <span className="text-sm text-foreground-800 group-hover:text-foreground-950 font-medium">{cat.name}</span>
                <i className="ri-external-link-line text-foreground-300 group-hover:text-accent-500 ml-auto w-4 h-4 flex items-center justify-center"></i>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}